document.addEventListener('DOMContentLoaded', function () {

    // Load more products
    let url = '';
    const load_btn = document.querySelector(".custom-filter-load-more");
    let products_on_page = document.querySelector('.collection-grid');
    const spinner = document.querySelector('.load-more-spinner');

    if (products_on_page) {
        url = products_on_page.getAttribute('data-next-url');
    }

    if (load_btn) {
        if (url === '') {
            load_btn.style.display = 'none';
        }

        load_btn.addEventListener("click", () => {
          spinner.classList.add("show");

          fetch(url)
            .then(function (response) {
              if (response.ok) {
                return response.text();
              } else {
                throw new Error('Network response was not ok.');
              }
            })
            .then(function (data) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(data, 'text/html');

              let links = doc.querySelector('.pagination-links')?.innerHTML;
              if (links) {
                document.querySelector('.pagination-links').innerHTML = links;
              }

              let new_grid = doc.querySelector('.collection-grid');
              url = new_grid.getAttribute('data-next-url');
              if (url === '') {
                load_btn.style.display = 'none';
              }

              // Get the innerHTML of the new grid and append it directly
              let new_products_html = '';
              let new_products = new_grid.querySelectorAll(".prd-Card, #collection-grid-cta, #collection-grid-cta-2");

              new_products.forEach(new_prod => {
                new_products_html += new_prod.outerHTML;
              });

              products_on_page.insertAdjacentHTML('beforeend', new_products_html);

              spinner.classList.remove("show");
            })
            .catch(function (error) {
              window.log(error);
            });
        });
    }

    const rangeInput = document.querySelectorAll(".range-input input");
    if (rangeInput) {
        const priceInput = document.querySelectorAll(".price-input-show");
        const range = document.querySelector(".slider .progress");
        const minFilterInput = document.querySelector('.min-price-filter');
        const maxFilterInput = document.querySelector('.max-price-filter');
        let priceGap = 1;

        if (maxFilterInput) {
            range.style.left = ((minFilterInput.value / rangeInput[0].max) * 100) + "%";
            range.style.right = 100 - (maxFilterInput.value / rangeInput[1].max) * 100 + "%";
            rangeInput[0].value = minFilterInput.value;
            rangeInput[1].value = maxFilterInput.value;
            priceInput[0].innerHTML = minFilterInput.value;
            priceInput[1].innerHTML = maxFilterInput.value;
        }

        priceInput.forEach(input => {
            input.addEventListener("input", e => {
                let minPrice = parseInt(priceInput[0].innerHTML);
                let maxPrice = parseInt(priceInput[1].innerHTML);

                if ((maxPrice - minPrice >= priceGap) && maxPrice <= rangeInput[1].max) {
                    if (e.target.className === "input-min") {
                        rangeInput[0].value = minPrice;
                        rangeInput[0].setAttribute("data-term", minPrice);
                        range.style.left = ((minPrice / rangeInput[0].max) * 100) + "%";
                    } else {
                        rangeInput[1].value = maxPrice;
                        maxFilterInput.value = maxVal;
                        range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
                    }
                }
            });
        });

        rangeInput.forEach(input => {
            input.addEventListener("input", e => {
                let minVal = parseInt(rangeInput[0].value),
                    maxVal = parseInt(rangeInput[1].value);

                if ((maxVal - minVal) < priceGap) {
                    if (e.target.className === "range-min") {
                        rangeInput[0].value = maxVal - priceGap
                    } else {
                        rangeInput[1].value = minVal + priceGap;
                    }
                } else {
                    priceInput[0].innerHTML = minVal;
                    priceInput[1].innerHTML = maxVal;
                    range.style.left = ((minVal / rangeInput[0].max) * 100) + "%";
                    range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
                    minFilterInput.value = minVal;
                    maxFilterInput.value = maxVal;
                }
            });
        });
    }


    let custom_filters = document.querySelectorAll(".custom-filter")

    custom_filters.forEach((el) => {

        let control = el.querySelector(".filter-heading")
        let body = el.querySelector(".filter-body")

        if (control && body) {

            control.addEventListener('click', () => {

                if (el.classList.contains("open")) {
                    el.classList.remove("open")
                } else {
                    el.classList.add("open")
                }

            })
        }
    })

    let mobile_control = document.querySelector(".mobile-filter-heading")
    let filter_body = document.querySelector(".custom-filter-wrapper")

    if (mobile_control && filter_body) {
        mobile_control.addEventListener('click', () => {
            // rotate svg
            if (mobile_control.classList.contains("open")) {
                mobile_control.classList.remove("open")
            } else {
                mobile_control.classList.add("open")
            }

            // open filters
            if (filter_body.classList.contains("open")) {
                filter_body.classList.remove("open")
            } else {
                filter_body.classList.add("open")
            }
        })
    }

    // Hide reset filters when no filters active
    const reset_filters = document.querySelector('.reset-filter-wrapper');
    const selected_filters_html = document.querySelectorAll('.selected-filter-wrapper *');

    if (selected_filters_html.length > 0) {
        reset_filters.style.display = 'block';
    }

    selected_filters_html.forEach(selected => {
        selected.addEventListener('click', () => {
            collection_grid.classList.add("loading")
        })
    })

// Utility: parse query string into params object (key -> array of values)
function parseParams(queryString) {
    const params = {};
    if (!queryString) return params;

    queryString.split('&').forEach(param => {
      const [key, value] = param.split('=');
      if (key && value) {
        if (!params[key]) params[key] = [];
        params[key].push(value);
      }
    });

    return params;
  }

  // Utility: serialize params object back to query string
  function serializeParams(params) {
    const parts = [];
    for (const key in params) {
      params[key].forEach(value => {
        parts.push(`${key}=${value}`);
      });
    }
    return parts.join('&');
  }

  function onFilterChange(event) {
    event.preventDefault();
    collectionGrid.classList.add('loading');

    // Parse current URL params
    const currentUrlParams = new URLSearchParams(window.location.search);
    const availabilityWasInUrl = currentUrlParams.has('filter.v.availability');
    const sizeWasInUrl = currentUrlParams.has('filter.v.option.size');

    // Serialize current form data
    const formData = new FormData(filterForm);
    const queryParts = [];
    let availabilityInForm = false;

    for (const [key, value] of formData.entries()) {
      if (key === 'filter.v.availability') {
        availabilityInForm = true;
      }
      queryParts.push(`${key}=${encodeURIComponent(value)}`);
    }

    let searchParams = queryParts.join('&');
    const params = parseParams(searchParams);

    const hasSize = params['filter.v.option.size'] && params['filter.v.option.size'].length > 0;
    const hasAvailability = params['filter.v.availability'] && params['filter.v.availability'][0] === '1';
    const hasAvailabilityZero = params['filter.v.availability'] && params['filter.v.availability'][0] === '0';

    // Only add availability=1 if:
    // - size selected now
    // - availability not selected now
    // - availability was NOT present in URL before
    // - AND size was NOT present in URL before (so user is not deselecting availability when size was already selected)
    if (
      hasSize &&
      !hasAvailability &&
      !hasAvailabilityZero &&
      !availabilityInForm &&
      !availabilityWasInUrl &&
      !sizeWasInUrl
    ) {
      params['filter.v.availability'] = ['1'];
      searchParams = serializeParams(params);
    }

    const action = filterForm.getAttribute('action') || window.location.pathname;
    window.location.href = `${action}?${searchParams}`;
  }


  // Select elements
  const filterInputs = document.querySelectorAll('.filter-container-wrapper select, .filter-container-wrapper input');
  const filterForm = document.querySelector('.filter-container');
  const resetFilter = document.querySelector('#reset-filters');
  const collectionGrid = document.querySelector('.collection-grid');

  // Attach event listeners
  filterInputs.forEach(input => input.addEventListener('change', onFilterChange));

  if (resetFilter) {
    resetFilter.addEventListener('click', () => {
      collectionGrid.classList.add('loading');
    });
  }

  updateSizeFilterCountsWithAvailability();

})

function updateSizeFilterCountsWithAvailability() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('filter.v.availability') || urlParams.has('filter.v.option.size')) {
        return;
    }

    const filterSize = document.querySelector('#size-filter');
    const filterForm = document.querySelector('.filter-container');
    if (!filterSize || !filterForm) return;

    const action = filterForm.getAttribute('action') || window.location.pathname;

    const formData = new FormData(filterForm);
    const baseParams = new URLSearchParams();
    for (let [key, value] of formData.entries()) {
      if (key !== 'filter.v.option.size' && key !== 'filter.v.availability') {
        baseParams.append(key, value);
      }
    }

    // Add 'hidden' class to all product-count spans to fade them out
    filterSize.querySelectorAll('.product-count').forEach(countSpan => {
        countSpan.classList.add('d-none');
    });

    const fetchPromises = [];

    filterSize.querySelectorAll('[data-param]').forEach(el => {
      const dataParam = el.getAttribute('data-param');
      if (!dataParam) return;

      const [paramKey, paramValue] = dataParam.split('=');
      const params = new URLSearchParams(baseParams.toString());
      params.append(paramKey, paramValue);
      params.set('filter.v.availability', '1');
      const fetchUrl = `${action}?${params.toString()}`;

      const fetchPromise = fetch(fetchUrl)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const updatedEl = doc.querySelector(`#size-filter [data-param="${paramKey}=${paramValue}"]`);
          if (!updatedEl) return null;
          console.log('Updated element:', updatedEl);

          const updatedCountSpan = updatedEl.querySelector('.product-count');
          return { el, updatedCountSpan };
        })
        .catch(err => {
          console.error('Error updating size filter count:', err);
          return null;
        });

      fetchPromises.push(fetchPromise);
    });

    Promise.all(fetchPromises).then(results => {
      results.forEach(result => {
        if (!result) return;
        const { el, updatedCountSpan } = result;
        const currentCountSpan = el.querySelector('.product-count');
        if (currentCountSpan && updatedCountSpan) {
          // Update product-count HTML
          currentCountSpan.innerHTML = updatedCountSpan.innerHTML;

          currentCountSpan.classList.add('d-none');

          // Check count number inside product-count, e.g. "(0)"
          const match = updatedCountSpan.textContent.match(/\((\d+)\)/);
          const count = match ? parseInt(match[1], 10) : null;

          const labelElement = el.closest('.label');
          if (labelElement) {
            if (count === 0) {
              labelElement.style.opacity = '0.5';
              labelElement.style.pointerEvents = 'none';
            }
          }
            currentCountSpan.classList.remove('d-none');
        }
      });
    });
  }
